export default "__VITE_PUBLIC_ASSET__aa1cede8__"